import React, { useEffect } from 'react'
import apiClient from '../../gears/apiClient';
import PageLoader from '../../components/PageLoader';
import { getDomainNameWithCompanyName } from '../../utility/utils';

const ClassLinkSsoReturn = () => {
  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const userData = await apiClient.get('/classlink/user-profile', {
          code: new URLSearchParams(window.location.search).get('code'),
        });

        if (userData.error) {
          throw new Error(userData.error);
        }

        window.location.replace(`${getDomainNameWithCompanyName(userData.company_name.toLowerCase())}/admin/login?token=${userData.token}`);
        return;
      } catch (e) {
        // window.location.replace(`/admin/login?error=${e.message}`);
      }
      window.location.replace('https://trial.hubbleiq.com/signup');
    };
    fetchUserProfile();
  }, []);

  return <PageLoader />;
}

export default ClassLinkSsoReturn;
